import { useFullTheme } from '~/design';
import { useResponsive } from '~/utils';

export interface InternalCountryFlagPlaceholderProps {
  value: string;
}

export function InternalCountryFlagPlaceholder({ value }: InternalCountryFlagPlaceholderProps) {
  const theme = useFullTheme();
  const responsive = useResponsive();
  return (
    <div
      css={{
        ...responsive.css(theme.typography.labelS),
        ...theme.borders.regular,
        backgroundColor: theme.colors.bgRegular,
        borderRadius: '2px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.625rem', // fixing the size bc I don't want this to be responsive
        height: '16px',
        width: '24px',
      }}
    >
      {value}
    </div>
  );
}
